import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { Icon } from '../icon'

import styles from './cart-urgency.module.scss'
import ClockIcon from './icons/clock_v2.inline.svg'

interface CartUrgencyProps {
  className?: string
}

export const CartUrgencyLegacy = ({ className }: CartUrgencyProps) => {
  const { t } = useTranslation('common')

  return (
    <div className={classNames(styles.cartUrgencyMessage, className)}>
      <Icon iconSvg={ClockIcon} className={styles.clockIcon} /> {t('selling_fast_miss_out')}
    </div>
  )
}
